import React, { useState } from 'react';
import { ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
import { useTranslation } from 'react-i18next';
import Icon from '../../components/Icon';
import StatDropdown from './StatDropdown';
import { REVENUE_BREAKDOWN } from '../mockData';

const formatShort = (value) => `${(value / 1000).toFixed(1)}K`;

const RevenueBreakdown = () => {
  const { t } = useTranslation();
  const [activeId, setActiveId] = useState(REVENUE_BREAKDOWN[1].id);

  const active = REVENUE_BREAKDOWN.find((item) => item.id === activeId) || REVENUE_BREAKDOWN[0];
  const options = REVENUE_BREAKDOWN.map((item) => ({ value: item.id, label: item.name, color: item.color }));

  return (
    <section className="stats-card stats-chart-card">
      <header className="stats-card-head">
        <div>
          <h3 className="stats-card-title">{t('statistics.revenue.title')}</h3>
          <p className="stats-card-subtitle">{t('statistics.revenue.subtitle')}</p>
        </div>
        <div className="stats-card-actions">
          <StatDropdown value={activeId} options={options} onChange={setActiveId} dotColor={active.color} />
          <button type="button" className="stats-btn">
            <Icon name="upload" size={14} />
            {t('statistics.export')}
          </button>
        </div>
      </header>

      <div className="stats-donut-layout">
        <div className="stats-donut">
          <ResponsiveContainer width="100%" height={260}>
            <PieChart>
              <Pie
                data={REVENUE_BREAKDOWN}
                dataKey="value"
                nameKey="name"
                innerRadius="62%"
                outerRadius="100%"
                paddingAngle={0}
                stroke="none"
                startAngle={90}
                endAngle={-270}
                isAnimationActive={false}
              >
                {REVENUE_BREAKDOWN.map((item) => (
                  <Cell
                    key={item.id}
                    fill={item.color}
                    opacity={item.id === activeId ? 1 : 0.85}
                    onMouseEnter={() => setActiveId(item.id)}
                    style={{ cursor: 'pointer' }}
                  />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
          <div className="stats-donut-center">
            <span className="stats-donut-value">{formatShort(active.value)}</span>
            <span className="stats-donut-label">{active.name}</span>
          </div>
        </div>

        <ul className="stats-legend">
          {REVENUE_BREAKDOWN.map((item) => (
            <li key={item.id}>
              <button
                type="button"
                className={`stats-legend-row${item.id === activeId ? ' active' : ''}`}
                onClick={() => setActiveId(item.id)}
              >
                <span className="stats-legend-name">
                  <span className="stats-dot" style={{ background: item.color }} />
                  {item.name}
                </span>
                <span className="stats-legend-values">
                  <span className="stats-legend-amount">{formatShort(item.value)}</span>
                  <span className="stats-legend-share">{item.share}%</span>
                </span>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default RevenueBreakdown;
